import { FormControlLabel, Checkbox } from "@mui/material";
import { FONT_SIZES } from "@/constants/Fonts/font_sizes";
import { FONTS } from "@/constants/Fonts/fonts";

export default function ColorCheckBox({ label }) {
  return (
    <FormControlLabel
      label={label}
      control={<Checkbox />}
      sx={{
        mr: -1,
        "& .MuiFormControlLabel-label": {
          fontSize: FONT_SIZES.SMALL,
          fontFamily: FONTS.BOLD,
        },
        "& .MuiSvgIcon-root": { fontSize: FONT_SIZES.REGULAR },
      }}
    />
  );
}
